"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readAuthorizeMetadata = exports.writeAuthorizeMetadata = exports.Authorize = void 0;
const AUTHORIZE_META_SYM = Symbol.for("@leavy/cq/RPC_INVOCABLE_METADATA");
function Authorize(options) {
    return (target) => {
        writeAuthorizeMetadata(target, options !== null && options !== void 0 ? options : {});
    };
}
exports.Authorize = Authorize;
function writeAuthorizeMetadata(target, meta) {
    target[AUTHORIZE_META_SYM] = meta;
}
exports.writeAuthorizeMetadata = writeAuthorizeMetadata;
function readAuthorizeMetadata(target) {
    var _a;
    return (_a = target[AUTHORIZE_META_SYM]) !== null && _a !== void 0 ? _a : null;
}
exports.readAuthorizeMetadata = readAuthorizeMetadata;
//# sourceMappingURL=Authorize.js.map